/** macOS, iPadOS and iOS: keyboard shortcuts use ⌘ there, Ctrl everywhere else. */
export function isApplePlatform(): boolean {
  return /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent)
}

/** The search shortcut as this keyboard shows it. */
export function searchShortcutLabel(): string {
  return isApplePlatform() ? '⌘K' : 'Ctrl K'
}

/** ⌘K on Apple keyboards, Ctrl+K elsewhere. Ctrl+K on a Mac stays the native
 *  "delete to end of line" in text fields. */
export function isSearchShortcut(event: KeyboardEvent): boolean {
  const modifier = isApplePlatform() ? event.metaKey : event.ctrlKey
  return modifier && !event.altKey && !event.shiftKey && event.key.toLowerCase() === 'k'
}
